var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88441 9.52245L12.1351 5.2718V24.0996C12.1351 24.8122 12.7134 25.3904 13.4259 25.3904C14.1384 25.3904 14.7167 24.8122 14.7167 24.0996V5.2718L18.9674 9.52245C19.2191 9.77481 19.5495 9.90066 19.88 9.90066C20.2104 9.90066 20.5409 9.77481 20.7926 9.52245C21.2966 9.01839 21.2966 8.2013 20.7926 7.69724L14.3385 1.24316C13.8351 0.739096 13.0167 0.739096 12.5133 1.24316L6.0592 7.69724C5.55514 8.2013 5.55514 9.01839 6.0592 9.52245C6.56262 10.0265 7.38099 10.0265 7.88441 9.52245Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 21.518C24.3301 21.518 23.7518 22.0963 23.7518 22.8088V27.9721C23.7518 28.684 23.1728 29.2629 22.461 29.2629H4.38954C3.67765 29.2629 3.09872 28.684 3.09872 27.9721V22.8088C3.09872 22.0963 2.52044 21.518 1.80791 21.518C1.09538 21.518 0.51709 22.0963 0.51709 22.8088V27.9721C0.51709 30.1077 2.25388 31.8445 4.38954 31.8445H22.461C24.5966 31.8445 26.3334 30.1077 26.3334 27.9721V22.8088C26.3334 22.0963 25.7551 21.518 25.0426 21.518Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.878b0b6960f4f1bab527ff06a62842f8.svg";
export { ForwardRef as ReactComponent };